import React, { useState, useEffect, useCallback } from 'react'
import { Heading, Table, Button, Dialog, toaster, Checkbox } from 'evergreen-ui'
import RoundBtn from '../../Components/RoundBtn'
import InviteForm from './InviteForm'
import ResourceForm from './ResourceForm'
import { connect } from 'react-redux'
import { setLoading, unsetLoading } from '../../Redux/reducers/loading';
import EditForm from '../../Components/EditForm'
import axios from '../../Utils/axios';
const Employee = ({
  dispatch, company, loading
}) => {
  const initialStateEmployeeResource = { opened: false, employeeId: null };
  const [openModal, setModalForm] = useState(false)
  const [employeeResource, setEmployeeResource] = useState(initialStateEmployeeResource)
  const [edit, setEdit] = useState(null)
  const [employees, setEmployees] = useState([])
  const [showInactives, setShowInactives] = useState(true)

  const getEmployees = useCallback(async () => {
    dispatch(setLoading())
    try {
      const { data } = await axios.get(`/company/employees`)
      setEmployees(data.employees)
    }
    catch (error) {
      toaster.danger('Falha ao buscar dados')
    }
    finally {
      dispatch(unsetLoading())
    }
  }, [dispatch])

  useEffect(() => {
    getEmployees()
  }, [getEmployees])

  const save = async (user) => {
    try {
      await axios.put(`/company/employees/${user.__id__}`, {
        name: user.name,
        active: user.active,
        usesTimeClock: user.usesTimeClock,
        document: user.document
      })

      let employeesList = employees.filter(employee => employee.__id__ !== user.__id__)
      setEmployees([
        ...employeesList,
        user
      ])
      toaster.success('Usuário alterado com sucesso.')
      setEdit(null)
    }
    catch (error) {
      if (error.response) {
        toaster.danger(error.response.data.error.message)
      }
      else {
        toaster.danger('Falha na comunicação com o servidor')
      }
    }
  }

  async function resendInvite({ __id__ }) {
    dispatch(setLoading())
    try {
      const { status } = await axios.put(`/company/employees/invite/${__id__}`, {})

      if (status === 200) {
        await getEmployees()
        toaster.success('Convite enviado ao funcionário')
        setEdit(null)
      }
    } catch (error) {
      if (error.response) {
        return toaster.danger(error.response.data.error.message)
      }
      toaster.danger('Falha ao enviar o convite')
    }
    finally {
      dispatch(unsetLoading())
    }
  }

  async function saveInvite(payload) {
    dispatch(setLoading())
    try {
      const { status } = await axios.post(`/company/employees/`, payload)

      if (status === 201) {
        await getEmployees()
        toaster.success('Convite enviado ao funcionário')
        setModalForm(false)
      }
    } catch (error) {
      if (error.response) {
        return toaster.danger(error.response.data.error.message)
      }
      toaster.danger('Falha ao enviar o convite')
    }
    finally {
      dispatch(unsetLoading())
    }
  }

  async function saveEmployeeResources(id, payload) {
    try {
      await axios.put(`/company/employees/${id}`,payload)
      setEmployeeResource(initialStateEmployeeResource)
    } catch (error) {
      toaster.danger('Falha ao Buscar dados')
    }
  }
  

  return (
    <div>
      <Heading size={600}>
        Funcionários
      </Heading>

      <Checkbox label="Mostrar Inativos"
        checked={showInactives}
        onChange={({ target }) => setShowInactives(target.checked)}
      />

      <Table style={{ marginTop: 15 }}>
        <Table.Head>
          <Table.TextHeaderCell>
            Nome
          </Table.TextHeaderCell>
          <Table.TextHeaderCell>
            E-mail
          </Table.TextHeaderCell>
          <Table.TextHeaderCell>
            Status
          </Table.TextHeaderCell>
          <Table.TextHeaderCell width={300} flex="none">
            Ações
          </Table.TextHeaderCell>
        </Table.Head>
        <Table.VirtualBody height={600}>
          {employees.filter(employee => showInactives ? employee : employee.active).sort((a, b) => b.__id__ < a.__id__).map(employee => (
            <Table.Row key={employee.__id__}>
              <Table.TextCell>{employee.name}</Table.TextCell>
              <Table.TextCell>{employee.email}</Table.TextCell>
              <Table.TextCell>{employee.active ? 'Ativo' : 'Inativo'}</Table.TextCell>
              <Table.TextCell width={300} flex='none'>
                <Button
                  iconBefore='edit'
                  marginRight={20}
                  onClick={() => setEdit(employee)}
                > Editar </Button>
                <Button
                  iconBefore='known-vehicle'
                  marginRight={20}
                  onClick={() =>  setEmployeeResource({ opened: true, employeeId: employee.__id__ }) }
                > Recursos </Button>
              </Table.TextCell>
            </Table.Row>
          ))}
        </Table.VirtualBody>

      </Table >
      <RoundBtn disabled={loading} action={() => setModalForm(true)} />

      { edit && (
        <Dialog
          shouldCloseOnOverlayClick={false}
          isShown={!!edit}
          title="Altere o usuário"
          onCloseComplete={() => setEdit(null)}
          hasFooter={false}
        >
          
            <EditForm 
              user={edit} 
              edit={(result) => ( save(result) )} 
              invite={() => resendInvite(edit)} 
              showEdit={true} 
              showTimeClock={true}
              showDocID={true}
              />
        </Dialog>
        )
      }

      <Dialog
        shouldCloseOnOverlayClick={false}
        isShown={openModal}
        title="Faça o convite"
        onCloseComplete={() => setModalForm(false)}
        hasFooter={false}
      >
        <InviteForm save={(payload) => saveInvite(payload)} close={() => setModalForm(false)} />
      </Dialog>
      <Dialog
        shouldCloseOnOverlayClick={false}
        isShown={employeeResource.opened}
        title="Recursos"
        onCloseComplete={() => setEmployeeResource(initialStateEmployeeResource)}
        hasFooter={false}
        width={900}
        confirmLabel={"Confirmar"}
        cancelLabel={"Cancelar"}
        elevation={2}
      >
        <ResourceForm 
          employeeResource={employeeResource} 
          save={(payload) => saveEmployeeResources(employeeResource.employeeId, payload)}/>
      </Dialog>
    </div>
  )
}

const mapStateToProps = ({ auth, loading }) => ({
  company: auth.account.company, loading: loading.isLoading
})
export default connect(mapStateToProps)(Employee)